import { render, staticRenderFns } from "./SummaryProject.vue?vue&type=template&id=3f83ef0e&scoped=true"
import script from "./SummaryProject.vue?vue&type=script&lang=ts"
export * from "./SummaryProject.vue?vue&type=script&lang=ts"
import style0 from "./SummaryProject.vue?vue&type=style&index=0&id=3f83ef0e&prod&lang=scss"
import style1 from "./SummaryProject.vue?vue&type=style&index=1&id=3f83ef0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83ef0e",
  null
  
)

export default component.exports